<template>
  <div class="id-card">
    <div class="back">
      <span @click="goBack"><van-icon name="down" class="icon" /></span>
      <span class="page-name">身份证识别</span>
    </div>
    <div class="header">
      <div class="title">
        <div class="line" />
        <div class="title-text">
          拍照温馨提示
        </div>
      </div>
    </div>
    <div class="notes">
      <p class="first">
        请保证证件完整并占据照片80%以上，照片文字清晰可见，避免照片反光
      </p>
      <p class="two">
        因光线原因可能导致身份证识别错误，请仔细核对并验证信息
      </p>
    </div>
    <div class="identify-area">
      <div v-show="!showFrontImg" @change="frontHandleFile($event)">
        <input ref="fileBtn" type="file" class="refesh-input-file" accept="image/*">
      </div>
      <div v-if="!showFrontImg" class="img-content">
        <div class="box">
          <img :src="imgUrlPortrait" alt="">
          <p>点击上传身份证人像面照片</p>
        </div>
      </div>
      <div v-if="showFrontImg" class="new-img">
        <img ref="frontImage" :src="frontImage" alt="">
      </div>
      <div v-if="showFrontImg" class="tool-list">
        <div class="refesh" @change="frontHandleFile($event)">
          <input ref="fileBtn" type="file" class="refesh-input-files" accept="image/*">
          <img :src="imgUrlRefresh" alt="">
        </div>
        <img :src="imgUrlSpinner" alt="" @click="rotateImg('frontImage')">
        <img :src="imgUrlEnlarge" alt="" @click="enlargeImg('frontImage')">
      </div>
    </div>
    <div class="identify-area">
      <div v-show="!showBackImg" @change="backHandleFile($event)">
        <input ref="fileBtn" type="file" class="refesh-input-file" accept="image/*">
      </div>
      <div v-if="!showBackImg" class="img-content">
        <div class="box">
          <img :src="imgUrlNationalEmblem" alt="">
          <p>点击上传身份证国徽面照片</p>
        </div>
      </div>
      <div v-if="showBackImg" class="new-img">
        <img ref="backImage" :src="backImage" alt="">
      </div>
      <div v-if="showBackImg" class="tool-list">
        <div class="refesh" @change="backHandleFile($event)">
          <input ref="fileBtn" type="file" class="refesh-input-files" accept="image/*">
          <img :src="imgUrlRefresh" alt="">
        </div>
        <img :src="imgUrlSpinner" alt="" @click="rotateImg('backImage')">
        <img :src="imgUrlEnlarge" alt="" @click="enlargeImg('backImage')">
      </div>
    </div>
    <div class="OCR-form">
      <div class="form-item">
        <div class="item-left">
          姓名
        </div>
        <div class="item-right">
          <input v-model="identifyObj.name" type="text">
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          身份证号
        </div>
        <div class="item-right">
          <input v-model="identifyObj.idCardNumber" type="text">
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          地址
        </div>
        <div class="item-right address">
          <van-field
            v-model="identifyObj.residentialAddress"
            rows="1"
            autosize
            type="textarea"
          />
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          证件有效起期
        </div>
        <div class="item-right">
          <div class="time-left">
            <span>{{ identifyObj.startDate }}</span>
          </div>
          <div class="time-img" @click="showTimeSelect('startDate')">
            <img :src="imgUrlTime" alt="">
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          证件有效止期
        </div>
        <div class="item-right">
          <div class="time-left">
            <span>{{ identifyObj.endDate }}</span>
          </div>
          <div class="time-img" @click="showTimeSelect('endDate')">
            <img :src="imgUrlTime" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="sureOcr">
        确认
      </button>
    </div>
    <van-popup v-model="popupTimeVisible" position="bottom" close-on-click-overlay>
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="timeSure"
        @cancel="popupTimeVisible = false"
      />
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
import Compressor from 'compressorjs'
export default {
  components: {
    'Loading': Loading
  },
  props: {
    carOwnerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      imgUrlCamera: api.imgAllUrl + '/camera.png',
      imgUrlClose: api.imgAllUrl + '/img-close.png',
      imgUrlEnlarge: api.imgAllUrl + '/img-enlarge.png',
      imgUrlRefresh: api.imgAllUrl + '/img-refesh.png',
      imgUrlSpinner: api.imgAllUrl + '/img-spin.png',
      imgUrlTime: api.imgAllUrl + '/time-img.png',
      imgUrlPortrait: api.imgAllUrl + '/portrait.png',
      imgUrlNationalEmblem: api.imgAllUrl + '/national-emblem.png',
      switchs: false,
      showFrontImg: false, // 展示正面上传照片
      showBackImg: false, // 展示上传的反面照片
      showTips: false,
      isFront: false,
      isBack: false,
      frontImageDeg: 0,
      backImageDeg: 0,
      currentDate: new Date(),
      popupTimeVisible: false,
      minDate: new Date(),
      maxDate: new Date(2099, 12, 31),
      frontImage: '', // 身份证正面照片
      backImage: '', // 身份证反面照片
      status: '',
      identifyObj: {
        name: '', // 车主姓名
        idCardNumber: '', // 身份证号
        residentialAddress: '', // 地址
        startDate: '', // 证件有效起期
        endDate: '', // 证件有效止期
        dateOfBirth: ''
      },
      businessTypeObj: {
        'ZKICATM': 'NationalMarketing-InsuredInfo',
        'DP_OWXPA': 'OfficialWX-InsuredInfo'
      },
      systemOriginObj: {
        'ZKICATM': 'NationalMarketing',
        'DP_OWXPA': 'OfficialWX'
      }
    }
  },
  activated() {
    this.identifyObj.name = this.carOwnerInfo.carOwner
    this.identifyObj.residentialAddress = this.carOwnerInfo.ownerAddress
    this.$store.commit('setShow', false)
  },
  methods: {
    showTimeSelect(status) {
      this.status = status
      this.popupTimeVisible = true
    },
    goBack() {
      this.$emit('goBack')
    },
    closeTips() {},
    frontHandleFile(event) {
      const file = event.target.files[0]
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg'];
      const ext = file.name.toLowerCase().split('.').pop()
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      console.log(this.$refs.fileBtn, 'fileBtn')
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      if (file.size > 20 * 1000 * 1000) {
        this.$toast('图片大小超过20M，请重新选择')
        return false
      } else {
        const that = this
        new Compressor(file, {
          quality: 0.5,
          maxWidth: 1200,
          success(result) {
            const reader = new FileReader()
            reader.readAsDataURL(result)
            const channelCode = localStorage.getItem('setChannelCode')
            const userCode = localStorage.getItem('setSalesCode')
            reader.onload = function(e) {
              const name = new Date().getTime()
              const param = {
                fileName: name + '.png',
                imageInBase64Format: e.target.result,
                serviceProvider: 'INTSIG', // 服务提供商
                businessType: that.businessTypeObj[channelCode], // 系统业务类型：0核心业务系统（0电子投保单；1电子保单；）1数字化营销平台销管中心（0电子合同），必传
                systemOrigin: that.systemOriginObj[channelCode], // 系统来源（0核心业务系统；1数字化营销平台销管中心），必传
                businessNo: channelCode === 'ZKICATM' ? userCode : checkFormat.generateUUID() // 系统业务唯一标识（投保单号、保单号、个人代理人唯一标识），必传
              }
              that.frontImage = e.target.result
              that.showFrontImg = true
              that.$nextTick(() => {
                that.$refs.frontImage.style.width = ''
                that.$refs.frontImage.style.height = ''
                that.$refs.frontImage.style.transform = `rotate(-${that.backImageDeg}deg)`
              })
              that.frontImageDeg = 0
              that.switchs = true
              that.$http.post(api.identification_cards, param).then(res => {
                that.switchs = false
                if (res.data.rtnCode === '0000') {
                  that.identifyObj.name = res.data.name
                  that.identifyObj.idCardNumber = res.data.idCardNumber
                  that.identifyObj.residentialAddress = res.data.residentialAddress
                  that.identifyObj.dateOfBirth = res.data.dateOfBirth
                  that.identifyObj.frontFileId = res.data.fileId
                  that.isFront = true
                } else {
                  that.$toast(res.data.rtnMsg)
                }
              })
                .catch(err => {
                  console.log(err)
                  this.switchs = false
                })
            }
          }
        })
      }
    },
    backHandleFile(event) {
      const file = event.target.files[0]
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg'];
      const ext = file.name.toLowerCase().split('.').pop()
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      console.log(this.$refs.fileBtn, 'fileBtn')
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      if (file.size > 20 * 1000 * 1000) {
        this.$toast('图片大小超过20M，请重新选择')
        return false
      } else {
        const that = this
        new Compressor(file, {
          quality: 0.5,
          maxWidth: 1200,
          success(result) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            const channelCode = localStorage.getItem('setChannelCode')
            const userCode = localStorage.getItem('setSalesCode')
            reader.onload = function(e) {
              const name = new Date().getTime()
              const param = {
                fileName: name + '.png',
                imageInBase64Format: e.target.result,
                serviceProvider: 'INTSIG', // 服务提供商
                businessType: that.businessTypeObj[channelCode], // 系统业务类型：0核心业务系统（0电子投保单；1电子保单；）1数字化营销平台销管中心（0电子合同），必传
                systemOrigin: that.systemOriginObj[channelCode], // 系统来源（0核心业务系统；1数字化营销平台销管中心），必传
                businessNo: channelCode === 'ZKICATM' ? userCode : checkFormat.generateUUID() // 系统业务唯一标识（投保单号、保单号、个人代理人唯一标识），必传
              }
              that.backImage = e.target.result
              that.showBackImg = true
              that.$nextTick(() => {
                that.$refs.backImage.style.width = ''
                that.$refs.backImage.style.height = ''
                that.$refs.backImage.style.transform = `rotate(-${that.backImageDeg}deg)`
              })
              that.backImageDeg = 0
              that.switchs = true
              that.$http.post(api.oppositeIdentityCards, param).then(res => {
                that.switchs = false
                if (res.data.rtnCode === '0000') {
                  that.identifyObj.endDate = res.data.endDate
                  that.identifyObj.startDate = res.data.startDate
                  that.identifyObj.backFileId = res.data.fileId
                  that.isBack = true
                } else {
                  that.$toast(res.data.rtnMsg)
                }
              })
                .catch(err => {
                  console.log(err)
                  this.switchs = false
                })
            }
          }
        })
      }
    },
    rotateImg(imgType) {
      const img = new Image()
      img.src = this[imgType]
      this[`${imgType}Deg`] += 90
      if (this[`${imgType}Deg`] >= 360) {
        this[`${imgType}Deg`] = 0
      }
      if (this[`${imgType}Deg`] === 90 || this[`${imgType}Deg`] === 270) {
        if (Number(img.width) > Number(img.height)) {
          this.$refs[imgType].style.height = `${0.62 * 209}px`
          this.$refs[imgType].style.width = '209px'
          this.$refs[imgType].style.marginTop = (126 / 3.1) + 'px'
        }
      } else {
        if (Number(img.width) > Number(img.height)) {
          this.$refs[imgType].style.width = img.width + 'px'
          this.$refs[imgType].style.height = img.height + 'px'
        }
        this.$refs[imgType].style.marginTop = 0
      }
      this.$refs[imgType].style.transform = `rotate(${this[`${imgType}Deg`]}deg)`
    },
    enlargeImg(imgType) {
      this.$ImagePreview([this[imgType]])
    },
    timeSure(value) {
      this.identifyObj[this.status] = checkFormat.getTimeToDate(value)
      this.popupTimeVisible = false
    },
    sureOcr() {
      this.$emit('newSuccessOcr', this.identifyObj, this.isFront, this.isBack)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./idCardIdentify";
</style>



// WEBPACK FOOTER //
// src/pages/car/idCardIdentify/index.vue